import EnquiryConfirmationModal from './enquiry-confirmation-modal/enquiry-confirmation-modal-lazy';
import EnquiryFormModal from './enquiry-form-modal/enquiry-form-modal-lazy';
import MultiEnquiryModal from './multi-enquiry-modal/multi-enquiry-modal-lazy';

const EnquiryModalCollection = () => (
  <>
    <EnquiryFormModal />
    <EnquiryConfirmationModal />
    <MultiEnquiryModal />
  </>
);

export default EnquiryModalCollection;
